import Util from "../helpers/util";
var UtilObject = new Util();

// var phnoEmailIsUnique;

//var map, marker;
var OTP;

export default class CustomerSignUpPage {
  constructor() {
    this.formstep1 = $("#formstep1");
    this.formstep2 = $("#formstep2");
    this.formstep3 = $("#formstep3");

    this.customerDetailsForm = $("#customerDetailsForm");
    this.customerFullName = $("#customerFullName");
    this.customerPhone = $("#customerPhone");
    this.customerEmail = $("#customerEmail");
    this.customerPassword = $("#customerPassword");
    this.customerConfirmPassword = $("#customerConfirmPassword");
    //refferralcode
    this.referralCode = $("#refferalCodeDisplay");

    this.submitBtn = $(".customerSignUpsubmitBtn");

    this.saveChangesBtn = $("#saveChangesBtn");

    this.customerFullNameError = $("#customerFullNameError");
    this.customerPhoneNumberError = $("#customerPhoneNumberError");
    this.customerEmailError = $("#customerEmailError");
    this.customerPasswordError = $("#customerPasswordError");
    this.customerConfirmPasswordError = $("#customerConfirmPasswordError");

    //zero bounce validation
    // this.customerZeroBounceEmailError = $("#customerZeroBounceEmailError");

    this.verifyOtpModal = $("#verifyOtpModal");
    // this.OTPInputVerify = $("#otp-input-verify");
    // this.OTPSuccess = $("#otpError");

    this.verifyOTPDetails = $("#verify-OTP-details");
    this.verifyOTPBtn = $("#verify-OTP-btn");

    this.basicDetails_page = $(".customerSignUpDetails-page");

    this.otpInputVerify = $("#otpInputVerify");
    this.otpError = $("#otpError");
    this.verifyOtpModalClose = $("#verifyOtpModalClose");

    // this.loginSuccess = 0;

    // Registering Events
    this.bindEvents();
    //this.geocodePosition();
  }

  bindEvents = () => {
    UtilObject.createCookie("PREVIOUS_PAGE", baseURL + "customer", 30);

    globalThis.phnoEmailIsUnique = false;
    globalThis.userCreated = false;
    globalThis.prevPhoneNo = 0;
    globalThis.prevEmail = "old";

    this.submitBtn.on("click", this.doFormAction);
    $("#resend-OTP-btn").on("click", this.reSendOTP);
    this.verifyOTPBtn.on("click", this.verifyOtp);

    //refferral code
    //this.referralCode.on("click", this.showrefferalBox);

    this.saveChangesBtn.on("click", this.closeModal);
    this.verifyOtpModalClose.on("click", this.closeOTPModal);

    $(".refferalCodeDisplay").hide();
  };

  closeModal = () => {
    this.autoDetectModal.hide();
  };

  closeOTPModal = () => {
    this.verifyOtpModal.hide();
  };

  // showrefferalBox = () => {
  //   //to show refferral code text box
  //   $(".refferalCodeDisplay").show();
  //   //to hide refferral code button
  //   $("#refferalCodeDisplay").hide();
  //   //code for refferral
  // };

  //form validation
  doFormAction = async (e) => {
    phnoEmailIsUnique = false;
    e.preventDefault();

    let iscustomerFullNameValidated = this.customerFullName_validate();
    if (iscustomerFullNameValidated) {
      this.customerFullNameError.html("");
    }

    let iscustomerPhoneValidated = this.Phno_validate();
    if (iscustomerPhoneValidated) {
      this.customerPhoneNumberError.html("");
    } else {
    }

    let iscustomerEmailValidated = this.Email_validate();
    if (iscustomerEmailValidated) {
      this.customerEmailError.html("");
    }

    let iscustomerPasswordValidated = this.Password_validate();
    if (iscustomerPasswordValidated) {
      this.customerPasswordError.html("");
    }

    let iscustomerConfirmPasswordValidated = this.ConfirmPassword_validate();
    if (iscustomerConfirmPasswordValidated) {
      this.customerConfirmPasswordError.html("");
    }

    if (
      iscustomerFullNameValidated &&
      iscustomerPhoneValidated &&
      iscustomerEmailValidated &&
      iscustomerPasswordValidated &&
      iscustomerConfirmPasswordValidated
    ) {
      phnoEmailIsUnique = await this.phnoEmailIsUnique_validate();

      if (phnoEmailIsUnique) {
        this.customerEmailError.html("");
        this.customerPhoneNumberError.html("");
        this.verifyOtpModal.show();
        // this.Submit_Form();
        this.sendOtp();
      }
    }
  };

  reSendOTP = async () => {
    await this.sendOtp();
    $("#otpError").html("OTP Re-Sent");
    setTimeout(() => {
      $("#otpError").html("");
    }, 5000);
  };

  sendOtp = () => {
    return new Promise((resolve) => {
      $.ajax({
        type: "POST",
        url: baseURL + "api/customer/Account/sendOTPSignUp",
        headers: { Authorization: X_API_KEY },
        data: {
          Phone_Number: this.customerPhone.val(),
          Email_Address: this.customerEmail.val(),
        },
        success: (data) => {
          OTP = data.OTP;
          resolve(data);
        },
        error: (err) => {
          resolve(null);
        },
      });
    });
  };

  verifyOtp = async () => {
    //OTP = 1234;
    var verifyOtp = /^\d{4}$/;
    if (!this.otpInputVerify.val().match(verifyOtp)) {
      this.otpError.html("Enter the Correct OTP format");
    } else {
      if (OTP == this.otpInputVerify.val()) {
        this.otpError.html("OTP Verified");
        setTimeout(() => {
          this.verifyOtpModal.hide();
        }, 1500);

        //zero bounce check for email
        var emailValid = "invalid";
        await new Promise((resolve) => {
          $.ajax({
            url: baseURL + "api/customer/CustomerZeroBounce/zeroBounceCheck",
            type: "POST",
            data: {
              basicEmail: this.customerEmail.val().toLowerCase(),
            },
            success: () => {
              emailValid = "valid";
              resolve();
            },
            error: () => {
              resolve();
            },
          });
        });
        //zero bounce check is over

        //Store Customer details in the database
        $.ajax({
          type: "POST",
          url: baseURL + "api/customer/Account/verifyOTPSignUp",
          headers: { Authorization: X_API_KEY },
          data: {
            Phone_Number: this.customerPhone.val(),
            Password: this.customerPassword.val(),
            Customer_Name: this.customerFullName.val(),
            Email_Address: this.customerEmail.val().toLowerCase(),
            Referral_code: $("#customerRefferalCode").val(),
            Email_Status: emailValid,
          },
          success: (data) => {
            //inserting into user access table

            $.ajax({
              url: baseURL + "api/customer/Account/userAccessSignUp",
              type: "POST",
              data: {
                Role_Type: "Customer",
                Group_Type: "Customer",
                Phone_Number: this.customerPhone.val(),
                Password: this.customerPassword.val(),
                Customer_Name: this.customerFullName.val(),
                Email_Address: this.customerEmail.val().toLowerCase(),
                Serial_Number: data.Serial_Number,
              },
              success: () => {},
              error: () => {},
            });

            customerID = data.Customer_ID;
            this.setCustomerDetails();

            // var allCookies = UtilObject.getAllCookies();

            // setTimeout(() => {
            //   window.location = allCookies.PREVIOUS_PAGE;
            // }, 1500);
            var allCookies = UtilObject.getAllCookies();

            let redirectPage = baseURL + "customer";

            if (
              allCookies &&
              allCookies.PREVIOUS_PAGE &&
              !allCookies.PREVIOUS_PAGE.includes("Vendor")
            ) {
              redirectPage = allCookies.PREVIOUS_PAGE;
            }

            setTimeout(() => {
              window.location = redirectPage;
            }, 1500);
          },
          error: (err) => {},
        });
      } else {
        this.otpError.html("Enter the Correct OTP");
      }
    }
  };

  phnoEmailIsUnique_validate = async () => {
    var phone = false,
      email = false;

    await new Promise((resolve) => {
      let phoneFinished = false;
      let emailFinished = false;

      const checkFinish = () => {
        if (phoneFinished && emailFinished) resolve();
      };

      $.ajax({
        type: "POST",
        url: baseURL + "api/customer/Account/logInPhoneCustomer",
        headers: { Authorization: X_API_KEY },
        data: this.customerDetailsForm.serialize(),
        success: () => {
          phone = true;
          phoneFinished = true;
          checkFinish();
        },
        error: () => {
          this.customerPhoneNumberError.html("Phone Number already Exists");
          phoneFinished = true;
          checkFinish();
        },
      });

      $.ajax({
        type: "POST",
        url: baseURL + "api/customer/Account/emailIsUnique",
        headers: { Authorization: X_API_KEY },
        data: this.customerDetailsForm.serialize(),
        success: () => {
          email = true;
          emailFinished = true;
          checkFinish();
        },
        error: () => {
          if ($("#customerEmail").val() == "") {
            this.customerEmailError.html("Email Address is mandatory");
          } else {
            this.customerEmailError.html("Email Address already exists");
          }
          emailFinished = true;
          checkFinish();
        },
      });
    });

    if (phone && email) {
      return true;
    } else {
      return false;
    }
  };

  // CheckPhNoEmailExistsSuccess = (res) => {
  //   let retCode = res.Code;
  //

  //   if (retCode == 6) {
  //

  //     this.customerPhoneNumberError.html("Phone Number already exists");
  //     if (prevPhoneNo == this.customerPhone.val()) {
  //       phnoEmailIsUnique = true;
  //     } else {
  //       phnoEmailIsUnique = false;
  //     }
  //   }
  //   if (retCode == 7) {
  //     this.customerEmailError.html("Email already exists");

  //     if (prevEmail == this.customerEmail.val()) {
  //       phnoEmailIsUnique = true;
  //     } else {
  //       phnoEmailIsUnique = false;
  //     }
  //   }
  //   if (retCode == 8) {
  //     // this.emailError.html("Email and PhoneNo already exists");
  //     if (prevPhoneNo != this.customerPhone.val()) {
  //       this.phoneNumberError.html("Phone Number already exists");
  //     }
  //     if (prevEmail != this.customerEmail.val()) {
  //       this.emailError.html("Email already exists");
  //     }
  //     if (
  //       prevPhoneNo == this.customerPhone.val() &&
  //       prevEmail == this.customerEmail.val()
  //     ) {
  //       phnoEmailIsUnique = true;
  //     } else {
  //       phnoEmailIsUnique = false;
  //     }
  //   }
  //   if (retCode == 0) {
  //     // this.emailError.html("Email already exists");
  //

  //     phnoEmailIsUnique = true;
  //   }
  //

  //
  // };

  //validate functions

  customerFullName_validate = () => {
    let flag = true;
    var name = /^([a-zA-Z ]){3,100}$/;

    if (
      !(
        this.customerFullName.val().match(name) &&
        this.customerFullName.val().length >= 3 &&
        this.customerFullName.val().length <= 100
      )
    ) {
      this.customerFullNameError.html("Enter valid name");

      flag = false;
    }

    return flag;
  };

  //phoneno validation
  Phno_validate = () => {
    let flag = true;
    // var phoneno = /^\d{10}$/;
    var phoneno = /^[1-9]{1}[0-9]{9}$/;
    if (!this.customerPhone.val().match(phoneno)) {
      this.customerPhoneNumberError.html(
        "Please enter only 10 digits for mobile number",
      );

      flag = false;
    }

    return flag;
  };

  //email validation
  Email_validate = () => {
    let flag = true;
    var emailexample =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!this.customerEmail.val().match(emailexample)) {
      this.customerEmailError.html("Please enter a valid email");

      flag = false;
    }

    return flag;
  };

  //password validation
  Password_validate = () => {
    //
    // let flag = true;
    // var PasswordExample =
    //   /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{6,}$/;

    // if (!this.inputPassword.val().match(PasswordExample)) {
    //   this.passwordError.html(
    //     "Please use min 6 max 15 characters, at least one letter, one small alphabet, one number and one special character"
    //   );

    //   flag = false;
    // }

    // return flag;

    let flag = true;

    if (
      !(
        this.customerPassword.val().length >= 6 &&
        this.customerPassword.val().length <= 15
      )
    ) {
      this.customerPasswordError.html(
        "Password must be min 6 and max 15 characters",
      );

      flag = false;
    }

    return flag;
  };

  //confirm password validation
  ConfirmPassword_validate = () => {
    let flag = true;

    if (
      this.customerConfirmPassword.val() === "" ||
      this.customerConfirmPassword.val() !== this.customerPassword.val()
    ) {
      this.customerConfirmPasswordError.html(
        "Passwords do not match",
      );

      flag = false;
    }

    return flag;
  };

  Submit_Form = () => {
    this.phoneNumberError.html("");
    this.emailError.html("");

    if (!userCreated) {
      $.ajax({
        type: "POST",
        url: baseURL + "api/customer/Account/VerifyOTPSignUp",
        // data : {
        //     "name" : customerPhone,
        //     "password" : customerPassword
        //       },
        headers: { Authorization: X_API_KEY },
        data: this.customerDetailsForm.serialize(),
        statusCode: {
          400: function () {
            alert("400 status code! user error");
          },
          500: function () {
            alert("500 status code! server error");
          },
        },
        success: this.phoneExists,
        //  function (res) {
        //
        //
        //   if (res.code == 6) {
        //     this.phoneExists();
        //   }
        // },
        // error: function (res) {
        //
        //   this.phoneExists;
        // },
      });
    } else {
      prevPhoneNo = this.customerPhone.val();
      prevEmail = this.customerEmail.val();
      $.ajax({
        type: "POST",
        url: baseURL + "api/customer/Account/VerifyOTPUpdateDetails",
        // data : {
        //     "name" : phoneNumberInput,
        //     "category" : passwordInput
        //       },
        headers: { Authorization: X_API_KEY },
        data: this.customerDetailsForm.serialize(),
        statusCode: {
          400: function () {
            alert("400 status code! user error");
          },
          500: function () {
            alert("500 status code! server error");
          },
        },
        // success: this.afterDetailsUpdated,
        //  function (res) {
        //
        //
        //   if (res.code == 6) {
        //     this.phoneExists();
        //   }
        // },
        // error: function (res) {
        //
        //   this.phoneExists;
        // },
      });
    }
    this.otpInputVerify.val("");
    this.otpError.html("");
    this.verifyOTPBtn.removeClass("d-none");
  };

  // //zero bounce email
  // Validate_Email = () => {
  //   let userEmail = this.customerEmail.val();
  //   $.ajax({
  //     type: "POST",
  //     url: baseURL + "api/customer/CustomerZeroBounce/update",
  //     async: false,
  //     data: {
  //       basicEmail: userEmail,
  //     },
  //     //headers: { Authorization: X_API_KEY },
  //     success: function (res) {
  //
  //     },
  //   });
  // };
  // //

  phoneExists = (res) => {
    prevPhoneNo = this.customerPhone.val();
    prevEmail = this.customerEmail.val();

    let cust_id = res.Customer_ID;

    let retCode = res.Code;

    //

    // if (retCode == 6) {
    //   // this.phoneExists();
    //

    //   this.phoneNumberError.html("Phone Number already exists");
    // } else if (retCode == 7) {
    //   // this.phoneExists();
    //   this.emailError.html("Email already exists");
    // } else {
    //

    //this.Validate_Email();

    this.customerPhoneNumberError.html("");
    this.customerEmailError.html("");

    // document.location = "vendor_login";

    userCreated = true;

    //this.addressPost(cust_id);
    //this.venId.html(cust_id);//
    // this.GSTDetails_page.removeClass("d-none");
    // this.basicDetails_page.addClass("d-none");
    // this.formstep1.removeClass("current-item");
    // this.formstep3.addClass("current-item");

    // document.location = "vendor_gst_delivery_details";
    // }
  };

  setCustomerDetails = () => {
    //storing it in cookies - for JS
    UtilObject.createCookie("CUSTOMER_ID", customerID, 30);

    //Storing it in PHP
    $.ajax({
      url: baseURL + "api/customer/CustomerCookies/setSessionId",
      type: "POST",
      data: {
        data: {
          CUSTOMER_ID: customerID,
        },
      },
      success: (result) => {},
      error: (err) => {},
    });
  };
}

